import axios from "axios";
import NProgress from "nprogress";
import Cookies from "js-cookie";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.interceptors.request.use(
  (config) => {
    NProgress.start();
    config.headers["Accept"] = "application/json";
    config.headers["Content-Type"] = "application/json";
    const token = Cookies.get("jwt");
    if (token != "null") {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  function(error) {
    NProgress.done();
    //const originalRequest = error.config;

    return Promise.reject(error);
  }
);

export default axios;
